import React from 'react';
import PropTypes from 'prop-types';
import { responsivePropType } from '../../utils/responsiveProp';

import type { TitleProps, TitleComponent } from './types';
import { StyledTitle } from './Title.styles';
import type { PolymorphicRef } from '../../utils/types';

function _Title<C extends 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' = 'h1'>(
  props: TitleProps<C>,
  ref?: PolymorphicRef<C>
) {
  const { children, size = 'default', color = 'default', ...otherProps } = props;

  const commonProps = {
    size,
    color,
    ...otherProps,
  };

  return (
    <StyledTitle {...commonProps} ref={ref}>
      {children}
    </StyledTitle>
  );
}

export const Title = React.forwardRef(_Title) as TitleComponent;

Title.propTypes = {
  size: responsivePropType(PropTypes.oneOf(['xsmall', 'small', 'default', 'large'] as const)),
  wordBreak: PropTypes.bool,
  color: PropTypes.string,
  textAlign: responsivePropType(PropTypes.oneOf(['left', 'center', 'right'] as const)),
};
